package org.example.zone360.pages.authentication

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.createClubDirector
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.InputField
import org.example.zone360.componentss.FieldTitleText
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.isValidEmail
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement

@Composable
fun AddDirector(
    onDialogDismiss: () -> Unit,
    toastMessage: (String) -> Unit,
) {
    val scope = rememberCoroutineScope()
    val context = rememberPageContext()
    val sitePalette = ColorMode.current.toSitePalette()
    var showPassword by remember { mutableStateOf(false) }
    var showConfirmPassword by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }
    var isError by remember { mutableStateOf(false) }
    var serverError by remember { mutableStateOf(" ") }
    var message by remember { mutableStateOf("") }
    var passwordErrorText by remember { mutableStateOf(false) }
    var confirmPasswordText by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var confirmPassword by remember { mutableStateOf("") }
    var isConfirmPasswordError = confirmPasswordText.isNotEmpty()


    val performSignup = {
        if (!isLoading) {
            scope.launch {
                val email = (document.getElementById(Res.Id.emailInput) as HTMLInputElement).value
                val firstName =
                    (document.getElementById(Res.Id.firstName) as HTMLInputElement).value
                val lastName = (document.getElementById(Res.Id.lastName) as HTMLInputElement).value
                val password1 = (document.getElementById(Res.Id.passwordInput) as HTMLInputElement).value
                val confirmPassword1 = (document.getElementById(Res.Id.confirmPasswordInput) as HTMLInputElement).value


                when {

                    firstName.isEmpty() || lastName.isEmpty() -> {
                        isError = true
                    }

                    email.isEmpty() -> {
                        isError = true
                    }

                    !isValidEmail(email) -> {
                        isError = true
                    }

                    password1.isEmpty()  -> {
                        passwordErrorText = true
                        return@launch
                    }

                    confirmPassword1.isEmpty()  -> {
                        isConfirmPasswordError = true

                        confirmPasswordText = "Confirm Password is required"
                        return@launch
                    }

                    password1 != confirmPassword1 -> {
                        isConfirmPasswordError = true
                        confirmPasswordText = "Passwords do not match"
                        return@launch
                    }

                    password1.length < Constants.PASSWORD_LENGTH -> {
                        passwordErrorText = true
                        return@launch
                    }

                    else -> {
                        isLoading = true
                        isError = false

                        try {
                            val result = createClubDirector(
                                email = email,
                                password = password1,
                                firstName = firstName,
                                lastName = lastName,
                            )
                            if (result.error == null) {
                                toastMessage("Club director added successfully!")
                                org.example.zone360.components.showToast(ToastID.SUCCESS)
                                onDialogDismiss()
                            } else {
                                serverError = result.error
                                message = "Add director failed!"
                            }

                        } catch (e: Exception) {
                            serverError = e.message ?: "Unexpected error"
                            message = "Add Director Failed!"
                            org.example.zone360.components.showToast(ToastID.ERROR)
                        } finally {
                            isLoading = false
                        }
                    }
                }
            }
        }
    }
    Box(
        modifier = Modifier
            .position(Position.Fixed)
            .top(0.px)
            .left(0.px)
            .width(100.percent)
            .height(100.percent)
            .zIndex(99)
            .backgroundColor(Palette.Grey.rgbLight.copyf(alpha = 0.7f)),
        contentAlignment = Alignment.Center
    )
    {
        Box(
            modifier = Modifier
                .width(392.px)
                .position(Position.Fixed)
                .top(50.percent)
                .left(50.percent)
                .transform { translate((-50).percent, (-50).percent) }
                .borderRadius(6.px),
            contentAlignment = Alignment.Center
        ) {
            Box(
                Modifier.fillMaxWidth()
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .border(
                        width = 1.px,
                        color = sitePalette.textFieldBorderColor.rgb,
                        style = LineStyle.Solid
                    )
                    .borderRadius(6.px),
                contentAlignment = Alignment.Center
            ) {
                Column(Modifier.fillMaxWidth().padding(topBottom = 10.px, leftRight = 20.px)) {
                    Row(
                        modifier = Modifier.fillMaxWidth().margin(top = 5.px),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        FieldTitleText(text = "Add Club Director", marginBottom = 0.px)
                        FaXmark(
                            modifier = Modifier
                                .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                                .cursor(Cursor.Pointer)
                                .onClick { onDialogDismiss() },
                            size = IconSize.LG
                        )
                    }
                    FieldTitleTextNormal(text = "Email", marginTop = 10.px) {}
                    InputField(
                        "Please enter a valid email",
                        InputType.Email,
                        "",
                        Res.Id.emailInput,
                        isError,
                        3.px
                    )
                    FieldTitleTextNormal(text = "First Name", marginTop = 10.px) {}
                    InputField(
                        "Enter your first name", InputType.Text, "", Res.Id.firstName, isError, 3.px
                    )

                    FieldTitleTextNormal(text = "Last Name", marginTop = 10.px) {}
                    InputField(
                        "Enter your last name", InputType.Text, "", Res.Id.lastName, isError, 3.px
                    )

                    Row(
                        Modifier.fillMaxWidth().margin(top = 10.px),
                        horizontalArrangement = Arrangement.SpaceBetween,
                    ) {
                        FieldTitleTextNormal(text = "Password") {}
                        FieldTitleTextNormalSimple(
                            text = if (showPassword) "Hide" else "Show",
                            onClick = { showPassword = !showPassword },
                            isClickable = true,
                            color = sitePalette.primary.rgb
                        )
                    }
                    Column(modifier = Modifier.fillMaxWidth()) {
                        InputField(
                            inputType = if (showPassword) InputType.Text else InputType.Password,
                            onValueChange = {
                                password = it
                                passwordErrorText = password.isNotBlank() && password.length < Constants.PASSWORD_LENGTH

                            },
                            placeHolder = "",
                            id = Res.Id.passwordInput,
                            marginBottom = 3.px,
                            onEnterPress = performSignup
                        )
                        if (passwordErrorText) {
                            Box(modifier = Modifier.fillMaxWidth()) {
                                FieldTitleTextNormalSimple(
                                    text =  "Password must be at least ${Constants.PASSWORD_LENGTH} characters",
                                    marginTop = 3.px,
                                    fontSize = 11.px,
                                    color = sitePalette.textErrorColor.rgb,
                                )
                            }
                        }
                    }

                    Row(
                        Modifier.fillMaxWidth().margin(top = 10.px),
                        horizontalArrangement = Arrangement.SpaceBetween,
                    ) {
                        FieldTitleTextNormal(text = "Confirm Password") {}
                        FieldTitleTextNormalSimple(
                            text = if (showConfirmPassword) "Hide" else "Show",
                            onClick = { showConfirmPassword = !showConfirmPassword },
                            isClickable = true,
                            color = sitePalette.primary.rgb
                        )
                    }
                    Column(modifier = Modifier.fillMaxWidth()) {
                        InputField(
                            inputType = if (showConfirmPassword) InputType.Text else InputType.Password,
                            onValueChange = {
                                confirmPassword = it
                                isConfirmPasswordError = false
                                confirmPasswordText = ""
                            },
                            placeHolder = "",
                            id = Res.Id.confirmPasswordInput,
                            marginBottom = 3.px,
                            onEnterPress = performSignup
                        )
                        if (isConfirmPasswordError) {
                            Box(modifier = Modifier.fillMaxWidth()) {
                                FieldTitleTextNormalSimple(
                                    text = confirmPasswordText,
                                    marginTop = 3.px,
                                    fontSize = 11.px,
                                    color = sitePalette.textErrorColor.rgb,
                                )
                            }
                        }
                    }

                    Box(Modifier.margin(topBottom = 10.px)) { }
                    CommonButton(
                        text = "Save",
                        isLoading = isLoading,
                        onCLick = { performSignup() }
                    )

                    if (serverError.isNotEmpty()) {
                        Box(
                            modifier = Modifier.margin(topBottom = 10.px).fillMaxWidth(),
                            contentAlignment = Alignment.Center
                        ) {
                            FieldTitleTextNormalSimple(text = serverError,
                                fontSize = 13.px,
                                width = 100.percent,
                                textAlign = TextAlign.Center,
                                whiteSpace = WhiteSpace.PreWrap,
                                color = sitePalette.textErrorColor.rgb,
                                onClick = {})
                        }
                    }

                }

            }
        }
    }
}